"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarMonth = void 0;
var CalendarMonth_base_1 = require("./CalendarMonth.base");
var CalendarMonth_styles_1 = require("./CalendarMonth.styles");
var Utilities_1 = require("../../../Utilities");
exports.CalendarMonth = (0, Utilities_1.styled)(CalendarMonth_base_1.CalendarMonthBase, CalendarMonth_styles_1.getStyles, undefined, { scope: 'CalendarMonth' });
//# sourceMappingURL=CalendarMonth.js.map